import { useRouteError } from "react-router-dom";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";

export const ErrorBoundary = () => {
  const error = useRouteError() as Error;
  console.error(error);

  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
      <Alert severity="error">Oops, something went wrong!</Alert>
    </Box>
  );
};
